import { CodeBook, ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import { CodeBookPagedFilter, SaveResult, OibServiceResult, InstitutionCodeBook } from "../../models";
import { 
    CommitteeRole,
    CommitteeSearch,
    OibEmployee,
    RegionalCommittee, RegionalCommitteeInstitution,
    RegionalCommitteeInstitutionSearch, RegionalCommitteeSearch 
} from "../../models/Committee";

const apiUrlPrefix: string = "regional-committee";

export const searchRegionalCommittee = async (search: RegionalCommitteeSearch) => {
    return api.post(
        `${apiUrlPrefix}/search`,
        search
    ) as Promise<PagedResult<RegionalCommittee>>
}

export const getRegionalCommitteeById = async (id: number) => {
    return api.get(
        `${apiUrlPrefix}/get/${id}`
    ) as Promise<RegionalCommittee>
}

export const saveRegionalCommittee = async (item: RegionalCommittee) => {
    return api.put(
        `${apiUrlPrefix}/save`,
        item
    ) as Promise<SaveResult<RegionalCommittee>>
}

// Institutions
export const getInstitutionsByRegionalCommitteeId = async (id: number) => {
    return api.get(
        `${apiUrlPrefix}/get-institutions/${id}`
    ) as Promise<CodeBook[]>
}

export const getInstitutionsByCountyId = async (id: number) => {
    return api.get(
        `${apiUrlPrefix}/get-institutions-county/${id}`
    ) as Promise<CodeBook[]>
}

export const searchInstitutionRegionalCommittee = async (search: RegionalCommitteeInstitutionSearch) => {
    return api.post(
        `${apiUrlPrefix}/search-institutions`,
        search
    ) as Promise<PagedResult<RegionalCommitteeInstitution>>
}

// Statuses, Roles
export const getRegionalCommitteeStatusList = async () => {
    return api.get(
        `${apiUrlPrefix}/statuses-all`
    ) as Promise<CodeBook[]>
}

export const getRegionalCommitteeRoleList = async () => {
    return api.get(
        `${apiUrlPrefix}/roles-all`
    ) as Promise<CommitteeRole[]>
}

// Employees
export const searchRegionalCommitteeEmployee = async (search: CodeBookPagedFilter) => {
    return api.post(
        `${apiUrlPrefix}/search-employees`,
        search
    ) as Promise<PagedResult<CodeBook>>
}

export const getRegionalCommitteeEmployeeOib = async (oib: string) => {
    return api.get(
        `${apiUrlPrefix}/oib/${oib}`
    ) as Promise<OibServiceResult<OibEmployee>>
}

// Export
export const getRegionalCommitteeListExport = async (search: RegionalCommitteeSearch, type: ExportTypeEnum) => {
    return api.download(
        `${apiUrlPrefix}/export/${type}`,
        "post",
        search
    ) as Promise<any>
}
